import React from "react";
import { useAccount } from "wagmi";
import styled from "@emotion/styled";
import { getEllipsisTxt } from "../../helpers/formatter";

const AccountBadge = () => {
  const [{ data: account }] = useAccount({
    fetchEns: true,
  });

  if (account) {
    return (
      <StyledBadge>
        {account.ens?.name ?? getEllipsisTxt(account.address, 4)}
      </StyledBadge>
    );
  }

  return <StyledBadge></StyledBadge>;
};

const StyledBadge = styled.div`
  // background: blue;
  color: #fff047;
  margin: 1em 2em;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.6em;
`;

export default AccountBadge;
